// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
    width: 100%;
    max-height: 500px; /* Adjust this height as needed */
    overflow-y: auto;
    overflow-x: hidden;
    border: 1px solid #ddd;
    position: relative;
}
#project-summary-table {
    /*width: 100%;*/
    border-collapse: collapse;
    font-size:16px;
}

#project-summary-table th, #project-summary-table td {
    border: 1px solid #4e4e4e;
    /*padding: 8px;*/

}

#project-summary-table thead th {
    background-color: #e2efda;
    position: sticky;
    top: 0;
    z-index: 2;
    font-size:16px;
    color: #691818;
    text-align: center; /* Center align the header text */
}

#project-summary-table th.title-column {
    /*width: 200%;*/
}

.project-td {
    color: black;
    font-size: 14px;
}

/*.region-summary-td {*/
/*    color: "black";*/
/*    background-color: "#ffc000";*/
/*}*/`, "",{"version":3,"sources":["webpack://./src/modules/project/components/css/ProjectsSummaryTable.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB,EAAE,iCAAiC;IACpD,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;;AAEpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,cAAc;IACd,cAAc;IACd,kBAAkB,EAAE,iCAAiC;AACzD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA,uBAAuB;AACvB,sBAAsB;AACtB,mCAAmC;AACnC,IAAI","sourcesContent":[".table-container {\n    width: 100%;\n    max-height: 500px; /* Adjust this height as needed */\n    overflow-y: auto;\n    overflow-x: hidden;\n    border: 1px solid #ddd;\n    position: relative;\n}\n#project-summary-table {\n    /*width: 100%;*/\n    border-collapse: collapse;\n    font-size:16px;\n}\n\n#project-summary-table th, #project-summary-table td {\n    border: 1px solid #4e4e4e;\n    /*padding: 8px;*/\n\n}\n\n#project-summary-table thead th {\n    background-color: #e2efda;\n    position: sticky;\n    top: 0;\n    z-index: 2;\n    font-size:16px;\n    color: #691818;\n    text-align: center; /* Center align the header text */\n}\n\n#project-summary-table th.title-column {\n    /*width: 200%;*/\n}\n\n.project-td {\n    color: black;\n    font-size: 14px;\n}\n\n/*.region-summary-td {*/\n/*    color: \"black\";*/\n/*    background-color: \"#ffc000\";*/\n/*}*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
